import React from 'react'
import PropTypes from 'prop-types'

import ComparableWrapper from 'agency/digital_renderer/components/ComparableWrapper'

import Comparable from './Comparable'
import styles from './styles.scss'

const renderComparables = (brand, comparables) => comparables.map(comparable => <Comparable key={comparable.id} brand={brand} campaignComparable={comparable} />)

const Comparables = (props) => {
  const { brand, campaign } = props

  return (
    <ComparableWrapper
      campaign={campaign}
      comparableSource="market"
      render={({ comparables }) => (
        <div className={styles.root}>
          <h4>Recent Relevant Listings</h4>

          <p className={styles.intro}>
            We&apos;ve researched comparable properties currently in the market. This has helped us understand which
            buyers to target and the likely price we can expect from your property.
          </p>

          <div className={styles.holder}>{renderComparables(brand, comparables)}</div>
        </div>
      )}
    />
  )
}

Comparables.propTypes = {
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Comparables
